import React from "react";
import arisLogo from "../../../Assets/icon/aris_logo.svg";

/**
 * Co-branded header bar: corporate logo on the left, separator, Aris logo on
 * the right. Matches Figma node 3:6809 (desktop) and 8:7287 (mobile).
 *
 * Falls back to the corporate display name as text if no logo_url is provided.
 */
const CorporateHeader = ({ branding }) => {
  const logoUrl = branding?.logo_url;
  const displayName = branding?.display_name || branding?.name || "";

  return (
    <div className="bg-white shadow-[0_0_6px_rgba(0,0,0,0.1)] flex items-center justify-center gap-8 py-4 md:py-9 px-4">
      <div className="flex items-center justify-center">
        {logoUrl ? (
          <img
            src={logoUrl}
            alt={displayName}
            className="max-h-9 md:max-h-[52px] max-w-[140px] md:max-w-[280px] object-contain"
          />
        ) : (
          <span className="font-semibold text-[#444] text-base md:text-lg">
            {displayName}
          </span>
        )}
      </div>
      <div className="h-9 md:h-[52px] w-px bg-[#d0d5dd]" aria-hidden="true" />
      <div className="flex items-center justify-center">
        <img
          src={arisLogo}
          alt="Aris"
          className="h-7 md:h-9 w-auto"
        />
      </div>
    </div>
  );
};

export default CorporateHeader;
